<div class="modal-header">
    <h4 class="modal-title">
        Edit: {{ adminClient?.firstName }} {{ adminClient?.lastName }} ({{ adminClient?.companyName }})
        <span *ngIf="adminClient?.isManualLead" class="badge bg-secondary ms-2" style="font-size: 12px; font-weight: 500"> <i class="fa-solid fa-hand me-1"></i> Manually Added </span>
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="editParkerForm" (ngSubmit)="onSubmit()" *ngIf="adminClient">
        <div class="mb-3">
            <label for="numberOfBays" class="form-label">Number of Bays</label>
            <input type="number" id="numberOfBays" class="form-control" formControlName="numberOfBays" />
        </div>

        <div class="mb-3">
            <label for="broadLocation" class="form-label">Broad Location</label>
            <select id="broadLocation" class="form-control" formControlName="broadLocation">
                <option value="">Select Location</option>
                <option *ngFor="let location of broadLocations" [value]="location">{{ location }}</option>
            </select>
        </div>

        <div class="mb-3">
            <label for="userResponsible" class="form-label">User Responsible</label>
            <select id="userResponsible" class="form-control" formControlName="userResponsible">
                <option value="">Select User</option>
                <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
            </select>
        </div>

        <div class="mb-3">
            <label for="leadStatus" class="form-label">Lead Status</label>
            <select id="leadStatus" class="form-control" formControlName="leadStatus">
                <option *ngFor="let status of leadStatuses" [value]="status">{{ status }}</option>
            </select>
        </div>

        <div class="mb-3" *ngIf="editParkerForm.get('leadStatus')?.value === LeadStatus.CLOSED">
            <label for="leadClosedReason" class="form-label">Closed Reason</label>
            <select id="leadClosedReason" class="form-control" formControlName="leadClosedReason">
                <option *ngFor="let reason of leadClosedReasons" [value]="reason">{{ reason }}</option>
            </select>
        </div>

        <div class="mb-3">
            <label for="comment" class="form-label">Comment</label>
            <textarea id="comment" class="form-control" formControlName="comment" rows="3" placeholder="Add a comment..."></textarea>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
</div>
